
// Throttle functions using `new ScrollThrottler(fn)` in componentDidMount
// Remember to use the destroy method in componentWillUnmount

export class ScrollThrottler {
  constructor(fn) {
    this.scrollTimeout = null;
    this.fn = fn;
    window.addEventListener('scroll', this.throttle, false);
  }

  throttle = () => {
    if (!this.scrollTimeout) {
      this.scrollTimeout = setTimeout(() => {
        this.scrollTimeout = null;
        this.fn();
      }, 16);
    }
  }

  destroy = () => {
    window.removeEventListener('scroll', this.throttle, false);
    this.scrollTimeout = null;
  }
}

export class ResizeThrottler {
  constructor(fn) {
    this.resizeTimeout = null;
    this.fn = fn;
    window.addEventListener('resize', this.throttle, false);
  }

  throttle = () => {
    if (!this.resizeTimeout) {
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = null;
        this.fn();
      }, 66);
    }
  }

  destroy = () => {
    window.removeEventListener('resize', this.throttle, false);
    this.resizeTimeout = null;
  }
}

export function convertDate(timestamp) {
  const date = new Date(timestamp);
  return ('0' + (date.getMonth() + 1)).slice(-2) + '.'
    + ('0' + date.getDate()).slice(-2) + '.'
    + date.getFullYear().toString().slice(2);
}

// Only hide :focus styles when the user is using a mouse

export function hideFocusStylesForMouse() {
  document.body.addEventListener('mousedown', () => {
    document.body.classList.add('using-mouse');
  });
  document.body.addEventListener('keydown', () => {
    document.body.classList.remove('using-mouse');
  });
}

// Blur tooltip for touch devices on touch away, since there's no close button

export function closeTooltipOnTouch() {
  document.body.addEventListener('touchstart', () => {
    if (/recent-assessments__flag/.test(document.activeElement.classList)) {
      document.activeElement.blur();
    }
  });
}

// Lock body scrolling when modals are open

export const bodyScroll = {
  scrollTop: 0,
  isLocked: false,
  lock(overrideTop = false) {
    this.scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const dom = document.querySelector('.body-content');
    dom.style.transform = `translateY(-${overrideTop ? 0 : this.scrollTop}px)`;
    dom.style.position = 'fixed';
    dom.style.overflow = 'hidden';
    this.isLocked = true;
  },
  unlock(overrideTop = false) {
    const dom = document.querySelector('.body-content');
    dom.style.transform = 'none';
    dom.style.position = 'static';
    dom.style.overflow = 'auto';
    if (!overrideTop) window.scrollTo(0, this.scrollTop);
    this.isLocked = false;
  },
  toggle(overrideTop = false) {
    if (this.isLocked) this.unlock(overrideTop);
    else this.lock(overrideTop);
  },
};



// WEBPACK FOOTER //
// ./src/utils/utils.js